import { RecordDataSource } from "../../../records/grids";
import {
  moneyValueGetterFactory,
  percentageValueGetterFactory,
} from "../../../records/grids/cells/valueGetters";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  vsServiceName as ColumnDefinitionSetServiceName,
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";

export const vsObjectName = "machineTypeId";

machineTypeIdConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];
export function machineTypeIdConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    ColumnDefinitionServiceName,
    ColumnDefinitionSetServiceName,
    (columnDefinitionService: ColumnDefinitionService) => [
      columnDefinitionService.getNumberColDef({
        field: "Id",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "Name",
        header: "Type ID",
      }),
      columnDefinitionService.getStringColDef({
        field: "Description",
      }),
      columnDefinitionService.getNumberColDef({
        field: "AverageGamePar",
        header: "Average Game Par",
        valueGetter: percentageValueGetterFactory(),
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "AverageParSheetPar",
        header: "Average Game Par Sheet Par",
        valueGetter: percentageValueGetterFactory(),
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "AverageRtp",
        header: "Average Game RTP",
        valueGetter: percentageValueGetterFactory(),
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "AverageGamePar",
        header: "Average Game Par",
        valueGetter: percentageValueGetterFactory(),
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MinMinCredit",
        header: "Min Min Credit",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MinMinBet",
        header: "Min Min Bet",
        valueGetter: moneyValueGetterFactory(),
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MaxMC",
        header: "Max M/C - Credits",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MaxMaxBet",
        header: "Max Max Bet",
        valueGetter: moneyValueGetterFactory(),
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "BvGlCode",
        header: "BV-G/L Code",
        hide: true,
      }),
      columnDefinitionService.getBooleanColDef({
        field: "SeriesFamily",
        header: "Series/Family",
      }),
      columnDefinitionService.getStringColDef({
        field: "MachineGameTypeName",
        header: "Game Type",
        hide: true,
      }),
      columnDefinitionService.getBooleanColDef({
        field: "FreePlayEnabled",
        header: "Free Play Enabled",
      }),
      columnDefinitionService.getBooleanColDef({
        field: "FirstToOregon",
        header: "First to Oregon",
      }),
      columnDefinitionService.getStringColDef({
        field: "ProgressiveDefinitionName",
        header: "Progressive",
      }),
      columnDefinitionService.getStringColDef({
        field: "ProgressiveMeterReadingSettingName",
        header: "Meter Reading Setting",
        hide: true,
      }),
      columnDefinitionService.getBooleanColDef({
        field: "ProgressiveMeterReadingSettingMeterReadingRequired",
        header: "Meter Reading Required",
        hide: true,
      }),
    ],
  ]);

  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ServerUtilityName,
    GridSettingsServiceName,
    (
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService
    ) => {
      return {
        columnDefinitionSet: vsObjectName,
        defaultSort: "Name",
        gridDataSource: new RecordDataSource(
          serverUtility,
          "/api/machines/MachineTypeId"
        ),
        nameSingular: "Type ID",
        gridSettings: gridSettingsService.getGridSettings(Symbol(vsObjectName)),
        showAddButton: true,
        showAddButtonPermission: "machineEdit",
      };
    },
  ]);
}
